import { useEffect, useState } from "react";
import { apiFetch, IS_STATIC } from "@/lib/api";
import { getContent, loadRemoteContent, hasLocalOverrides } from "@/lib/staticData";

const FALLBACK = [
  "Dulux Trade",
  "Haymes Paint",
  "Porter's Paints",
  "Master Painters Australia",
  "Adelaide Heritage Trust",
  "Architecture SA",
];

export default function PartnerMarquee() {
  const [partners, setPartners] = useState(IS_STATIC ? getContent().partners : FALLBACK);

  useEffect(() => {
    if (IS_STATIC) {
      loadRemoteContent().then((c) => {
        if (c && !hasLocalOverrides()) setPartners(c.partners);
      });
      return;
    }
    apiFetch("/partners")
      .then((list) => {
        if (Array.isArray(list) && list.length > 0)
          setPartners(list.map((p) => p.name));
      })
      .catch(() => {});
  }, []);

  const doubled = [...partners, ...partners];

  return (
    <section
      className="overflow-hidden border-b border-border py-8"
      data-testid="partner-logo-marquee"
      aria-label="Companies we work with"
    >
      <p className="mb-6 text-center font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
        Trusted by &amp; working with
      </p>
      <div className="relative">
        <div className="marquee-track flex w-max items-center gap-14 px-7">
          {doubled.map((name, i) => (
            <span key={`${name}-${i}`} className="flex items-center gap-14">
              <span className="whitespace-nowrap font-serif text-xl font-semibold tracking-tight text-muted-foreground/70 transition-colors duration-300 hover:text-accent sm:text-2xl">
                {name}
              </span>
              <span className="h-1.5 w-1.5 rounded-full bg-accent/50" aria-hidden="true" />
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-background to-transparent" />
      </div>
    </section>
  );
}
